const KYC = {
  GETTING_KYC_DETAILS: 'GETTING_KYC_DETAILS',
  GET_KYC_DETAILS_SUCCESS: 'GET_KYC_DETAILS_SUCCESS',
  GET_KYC_DETAILS_FAILURE: 'GET_KYC_DETAILS_FAILURE',
  CLEAR_KYC_DETAILS: 'CLEAR_KYC_DETAILS',

  GETTING_KYC_CHECKS: 'GETTING_KYC_CHECKS',
  GET_KYC_CHECKS_SUCCESS: 'GET_KYC_CHECKS_SUCCESS',
  GET_KYC_CHECKS_FAILURE: 'GET_KYC_CHECKS_FAILURE',
  CLEAR_KYC_CHECKS: 'CLEAR_KYC_CHECKS',

  UPDATING_KYC_DOC_STATUS: 'UPDATING_KYC_DOC_STATUS',
  UPDATE_KYC_DOC_STATUS_SUCCESS: 'UPDATE_KYC_DOC_STATUS_SUCCESS',
  UPDATE_KYC_DOC_STATUS_FAILURE: 'UPDATE_KYC_DOC_STATUS_FAILURE',

  GETTING_ALL_KYCS: 'GETTING_ALL_KYCS',
  GET_ALL_KYCS_SUCCESS: 'GET_ALL_KYCS_SUCCESS',
  GET_ALL_KYCS_FAILURE: 'GET_ALL_KYCS_FAILURE',
  CLEAR_ALL_KYCS: 'CLEAR_ALL_KYCS',

  SYNCING_USER_KYC: 'SYNCING_USER_KYC',
  SYNC_USER_KYC_SUCCESS: 'SYNC_USER_KYC_SUCCESS',
  SYNC_USER_KYC_FAILURE: 'SYNC_USER_KYC_FAILURE',

  SYNCING_VANCE_USER_KYC: 'SYNCING_VANCE_USER_KYC',
  SYNC_VANCE_USER_KYC_SUCCESS: 'SYNC_VANCE_USER_KYC_SUCCESS',

  UPDATING_CHECK_STATUS: 'UPDATING_CHECK_STATUS',
  UPDATE_CHECK_STATUS_SUCCESS: 'UPDATE_CHECK_STATUS_SUCCESS',
  UPDATE_CHECK_STATUS_FAILURE: 'UPDATE_CHECK_STATUS_FAILURE',

  CREATING_E_KYC: 'CREATING_E_KYC',
  CREATE_E_KYC_SUCCESS: 'CREATE_E_KYC_SUCCESS',
  CREATE_E_KYC_FAILURE: 'CREATE_E_KYC_FAILURE',

  CREATING_M_KYC: 'CREATING_M_KYC',
  CREATE_M_KYC_SUCCESS: 'CREATE_M_KYC_SUCCESS',
  CREATE_M_KYC_FAILURE: 'CREATE_M_KYC_FAILURE',

  //Fetching KYC TAGS
  GETTING_KYC_TAGS: 'GETTING_KYC_TAGS',
  GET_KYC_TAGS_SUCCESS: 'GET_KYC_TAGS_SUCCESS',
  GET_KYC_TAGS_FAILURE: 'GET_KYC_TAGS_FAILURE',

  // Fetching KYC Tiers
  GETTING_KYC_TIERS: 'GETTING_KYC_TIERS',
  GET_KYC_TIERS_SUCCESS: 'GET_KYC_TIERS_SUCCESS',
  GET_KYC_TIERS_FAILURE: 'GET_KYC_TIERS_FAILURE',

};

export default KYC;
